'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactSortableHoc = require('react-sortable-hoc');

var _SortableElement = require('./SortableElement');

var _SortableElement2 = _interopRequireDefault(_SortableElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports['default'] = (0, _reactSortableHoc.SortableContainer)((_temp = _class = function (_PureComponent) {
  _inherits(SortableContainer, _PureComponent);

  function SortableContainer() {
    _classCallCheck(this, SortableContainer);

    return _possibleConstructorReturn(this, (SortableContainer.__proto__ || Object.getPrototypeOf(SortableContainer)).apply(this, arguments));
  }

  _createClass(SortableContainer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            items = _props.items,
            Component = _props.component,
            other = _objectWithoutProperties(_props, ['items', 'component']);

        return _react2['default'].createElement(
          Component,
          other,
          items.map(function (element, index) {
            return _react2['default'].createElement(_SortableElement2['default'], _extends({ key: 'item-' + index }, { index: index, element: element }));
          })
        );
      }

      return render;
    }()
  }]);

  return SortableContainer;
}(_react.PureComponent), _class.propTypes = {
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  items: _PropTypes2['default'].array
}, _class.defaultProps = {
  component: 'div',
  items: []
}, _class.displayName = 'SortableContainer', _temp), {
  withRef: true
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/makeSortable/SortableContainer.js
// module id = 655
// module chunks = 32